import { AuthEmail } from 'types';

import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

import { Logout } from './types';

export const login = (payload: AuthEmail) => {
  // TODO: use real request
  return {
    data: {
      data: {
        token: 'a',
        refreshToken: 'b',
        user: { id: 1, name: payload.email, email: payload.email },
      },
    },
  };
  return apiLoaderInstance.post(URL.LOGIN, {
    ...payload,
  });
};

export const logout = (data: Logout) => {
  // TODO: use real request
  return {};
  return apiLoaderInstance.post(URL.LOGOUT, data);
};
